/**
 * 401 için tek giriş noktası.
 *
 * Uygulamada birbirinden bağımsız birkaç HTTP katmanı var (vue-resource api.js, axios/OtherApi,
 * Bryntum AjaxHelper, Bryntum store) ve her biri hatayı kendi yolunda işliyordu: yalnızca OtherApi
 * login'e yönlendiriyor, diğerlerinde kullanıcı bozuk ekranda toast görüp kalıyordu. Hepsi buraya
 * bağlanır, böylece 401 davranışı çağrının hangi istemciyle yapıldığına bağlı olmaktan çıkar.
 *
 * 401'in sebebi ayırt edilmiyor (backend X-Auth-Error ile token_missing/expired/invalid/revoked
 * gönderiyor); hepsinde sonuç aynı: oturum artık kullanılamaz, kullanıcı yeniden giriş yapmalı.
 * Mesaj varsa backend'in gövdesi kullanılır - o zaten yerelleştirilmiş düz metin.
 */

// Yönlendirme #/Logout'a yapılır (doğrudan #/Login'e değil): Logout.vue cookie'leri ve localStorage'ı
// temizliyor, aksi halde geçersiz token tarayıcıda kalır ve router guard onu geçerli sanar.
const LOGOUT_ROUTE = '#/Logout';

function isOnAuthRoute() {
  const hash = window.location.hash || '';
  return hash.indexOf('#/Login') === 0 || hash.indexOf('#/Logout') === 0;
}

export function handleUnauthorized(message) {
  // Zaten Login/Logout'tayız. Bu kontrol iki işi birden yapıyor:
  //  1) Döngü koruması - Logout.vue sunucuya çıkış isteği atıyor ve o istek de 401 alabilir (token
  //     zaten iptal/süresi geçmiş); koruma olmadan sonsuz yönlendirme döngüsü olur.
  //  2) Toplu istek koruması - hash ataması senkron olduğundan, ilk 401 yönlendirdikten sonra aynı
  //     ekrandan gelen diğer 401'ler buradan döner; tek toast, tek yönlendirme.
  if (isOnAuthRoute()) return;

  if (message) toastr.error(message);
  window.location = LOGOUT_ROUTE;
}

/**
 * Bryntum katmanları için: fetch tabanlı olduklarından 4xx'te reject ETMEZ, resolve ederler.
 * Yanıt aynen geri döndürülür - çağıranların akışı değişmez, yönlendirme yalnızca yan etki olarak olur.
 */
export function checkResponseForAuthFailure(response) {
  if (response && response.status === 401) handleUnauthorized();
  return response;
}
